import React from "react";
import { Spinner } from 'reactstrap';

const LoadingScreen = ({ description }) => (
  <div className='crm-loading-screen'>
    <div className='crm-spinners-container'>
      <div className='crm-spinners'>
        <Spinner type='grow' color="dark" />
        <Spinner type='grow' color="dark" />
        <Spinner type='grow' color="dark" />
      </div>
      <div className='crm-spinner-text'>
        {description}
      </div>
    </div>
  </div>
)

export default LoadingScreen;